<template>
  <v-container fluid>
    <!-- inicio de cambiar de rancho -->
    <v-row class="pa-0 ma-0 align-center"
           justify="center"
           no-gutters>
    <v-col cols="8" justify="justify-center" class="ma-0 pa-0">
      <ChangeRanch
        :paddock="paddockSelected"
        :paddocks="currentPaddocks">
      </ChangeRanch>
    </v-col>
    </v-row>
    <!-- fin de cambiar de rancho -->

    <!-- inicio de texto principal -->
    <v-row class="px-2 smart-title-2 home-title-container my-3"
           align="center"
           no-gutters>
      <v-col cols="12" class="d-flex align-center justify-center">
        <div class="unselectable">¿Cómo va él rancho?</div>
      </v-col>
    </v-row>
    <!-- fin de texto principal -->

    <!-- inicio de tarjeta de Celos -->
    <v-card flat elevation="5" class="my-3">
      <v-row no-gutters>
        <!-- inicio de area de titulo -->
        <v-col class="col-4 ltl-card-header-heat std-border-left-radius">
            <v-col cols="12"
                   class="ltl-card-icon-container no-gutters mx-auto mt-2 pa-0 d-flex align-end icon-container-heat">
              <img src="../assets/icons/icon_heat.png" alt="#"/>
            </v-col>
            <v-col class="col-12 pa-2">
              <h4 class="card-title ma-0">Celos a confirmar</h4>
            </v-col>
        </v-col>
        <!-- fin de area de titulo -->

        <!-- inicio de contadores -->
        <v-col class="col-8">
          <v-row no-gutters>
            <!-- inicio de contador superior -->
            <v-col cols="12"
                  class="d-flex card-counter-container my-2">
              <v-col class="col-5 d-flex align-center justify-center full-height pr-1 pl-0 py-0">
                <h1 class="card-number-3 unselectable">02</h1>
              </v-col>
              <div class="col-7 d-flex align-center justify-start pl-1 pr-0 py-0 full-height">
                <p class="card-text-2 unselectable">A revisar<br />hoy</p>
              </div>
            </v-col>
            <!-- fin de contador superior -->

            <!-- inicio de linea intermedia -->
            <v-col class="d-flex justify-center line-break"
                   cols="12">
              <div></div>
            </v-col>
            <!-- fin de linea intermedia -->

            <!-- inicio de contador inferior -->
            <v-col cols="12"
                   class="d-flex card-counter-container my-2">
              <div class="col-5 d-flex align-center justify-center full-height pr-1 pl-0 py-0">
                <h1 class="card-number-3 unselectable">02</h1>
              </div>
              <div class="col-7 d-flex align-center justify-start pl-1 pr-0 py-0 full-height">
                <p class="card-text-2 unselectable">Para seguimiento</p>
              </div>
            </v-col>
            <!-- fin de contador inferior -->
          </v-row>
        </v-col>
        <!-- fin de contadores -->
      </v-row>
    </v-card>
    <!-- fin de tarjeta de Celos -->

    <!-- inicio de tarjetas-->
    <v-row no-gutters class="my-3">
     <!-- inicio de tarjeta de DIM -->
      <v-col cols="4" class="full-height pr-2">
        <v-card class="full-height"
                flat
                elevation="5">
        <!-- inicio de header de tarjeta -->
        <v-col cols="12"
               class="d-flex align-center justify-center ltl-card-header">
          <h4 class="button-text">DIM</h4>
        </v-col>
        <!-- fin de header de tarjeta -->
        
        <!-- inicio de icono de tarjeta -->
        <v-col cols="12"
               class="ltl-card-icon-container mx-auto my-2 pa-0 d-flex align-end icon-container">
          <img src="../assets/icons/icon_dim.png" alt="#"/>
        </v-col>
        <!-- fin de icono de tarjeta -->

        <!-- inicio de texto de tarjeta -->
        <v-col cols="12"
               class="d-flex justify-center align-center ltl-card-number-container pa-1">
          <h1 class="card-number-2 unselectable">002</h1>
        </v-col>
        <!-- fin de texto de tarjeta -->
        </v-card>
      </v-col>
    <!-- fin de tarjeta de DIM -->

    <!-- inicio de tarjeta de Enfermas -->
         <v-col cols="4" class="full-height px-1">
          <v-card class="full-height"
                  flat
                  elevation="5">
          <!-- inicio de header de tarjeta -->
          <v-col cols="12"
                 class="d-flex align-center justify-center ltl-card-header">
            <h4 class="button-text">Enfermas</h4>
          </v-col>
          <!-- fin de header de tarjeta -->
          
          <!-- inicio de icono de tarjeta -->
          <v-col cols="12"
                 class="ltl-card-icon-container mx-auto my-2 pa-0 d-flex align-end icon-container">
            <img src="../assets/icons/icon_sick.png" alt="#"/>
          </v-col>
          <!-- fin de icono de tarjeta -->
  
          <!-- inicio de texto de tarjeta -->
          <v-col cols="12"
                 class="d-flex justify-center align-center ltl-card-number-container pa-1">
            <h1 class="card-number-2 unselectable">002</h1>
          </v-col>
          <!-- fin de texto de tarjeta -->
          </v-card>
        </v-col>
      <!-- fin de tarjeta de Enfermas -->

      <!-- inicio de tarjeta de Preñadas -->
           <v-col cols="4" class="full-height pl-2">
            <v-card class="full-height"
                    flat
                    elevation="5">
            <!-- inicio de header de tarjeta -->
            <v-col cols="12"
                   class="d-flex align-center justify-center ltl-card-header">
              <h4 class="button-text">Preñadas</h4>
            </v-col>
            <!-- fin de header de tarjeta -->
            
            <!-- inicio de icono de tarjeta -->
            <v-col cols="12"
                   class="ltl-card-icon-container mx-auto my-2 pa-0 d-flex align-end icon-container">
              <img src="../assets/icons/resumePregnant.svg" alt="#"/>
            </v-col>
            <!-- fin de icono de tarjeta -->
    
            <!-- inicio de texto de tarjeta -->
            <v-col cols="12"
                   class="d-flex justify-center align-center ltl-card-number-container pa-1">
              <h1 class="card-number-2 unselectable">002</h1>
            </v-col>
            <!-- fin de texto de tarjeta -->
            </v-card>
          </v-col>
      <!-- fin de tarjeta de Preñadas -->
      
    </v-row>
    <!-- fin de tarjetas-->
  
    <!-- inicio de tarjeta de Vacunacion -->
    <v-card flat elevation="5" class="my-3">
      <v-row no-gutters>
        <!-- inicio de area de titulo -->
        <v-col class="col-4 ltl-card-header-vaccinate std-border-left-radius">
            <v-col cols="12"
                   class="ltl-card-icon-container no-gutters mx-auto mt-2 pa-0 d-flex align-end icon-container-heat">
              <img src="../assets/icons/icon_vaccinate.png" alt="#"/>
            </v-col>
            <v-col class="col-12 pa-2">
              <h4 class="card-title ma-0">Vacunas y tratamíentos</h4>
            </v-col>
        </v-col>
        <!-- fin de area de titulo -->

        <!-- inicio de contadores -->
        <v-col class="col-8">
          <v-row no-gutters>
            <!-- inicio de contador superior -->
            <v-col cols="12"
                  class="d-flex card-counter-container my-2">
              <v-col class="col-5 d-flex align-center justify-center full-height pr-1 pl-0 py-0">
                <h1 class="card-number-3 unselectable">02</h1>
              </v-col>
              <div class="col-7 d-flex align-center justify-start pl-1 pr-0 py-0 full-height">
                <p class="card-text-2 unselectable">Por vacunar</p>
              </div>
            </v-col>
            <!-- fin de contador superior -->

            <!-- inicio de linea intermedia -->
            <v-col class="d-flex justify-center line-break"
                   cols="12">
              <div></div>
            </v-col>
            <!-- fin de linea intermedia -->

            <!-- inicio de contador inferior -->
            <v-col cols="12"
                   class="d-flex card-counter-container my-2">
              <div class="col-5 d-flex align-center justify-center full-height pr-1 pl-0 py-0">
                <h1 class="card-number-3 unselectable">02</h1>
              </div>
              <div class="col-7 d-flex align-center justify-start pl-1 pr-0 py-0 full-height">
                <p class="card-text-2 unselectable">Por tratar</p>
              </div>
            </v-col>
            <!-- fin de contador inferior -->
          </v-row>
        </v-col>
        <!-- fin de contadores -->
      </v-row>
    </v-card>
    <!-- fin de tarjeta de Vacunacion -->

    <!-- inicio de tarjeta de vacas en sistema -->
    <v-col cols="12" class="pa-0">
      <SystemCardCount height="40px"
                       width="100%"
                       number="100"
                       title-background="#57A7F5"
                       number-background="#1460AA"
                       title="Vacas en Sistema">
       </SystemCardCount>
    </v-col>
    <!-- fin de tarjeta de vacas en sistema -->

    <!-- inicio de contadores de animales -->
    <v-row no-gutters class="my-3">
      <!-- inicio de contadores de vaquillas -->
      <v-col class="full-height mr-2 d-flex align-center std-animal-count-container justify-space-between std-background-white-1 pa-1">
        <i class="std-icon std-heifer-blue-icon-mobile"></i>
        <div class="std-text-md std-text-blue-3 font-weight-bold">008</div>
      </v-col>
      <!-- fin de contadores de vaquillas -->
      <!-- inicio de contadores de toros -->
      <v-col class="full-height mx-2 d-flex align-center std-animal-count-container justify-space-between std-background-white-1 pa-1">
        <i class="std-icon std-bull-blue-icon-mobile"></i>
        <div class="std-text-md std-text-blue-3 font-weight-bold">008</div>
      </v-col>
      <!-- fin de contadores de toros -->
      <!-- inicio de botón de agregar vaca -->
      <v-btn class="ml-2 upper-cow-item smartbell-greenButton d-flex justify-space-around"
             depressed
             elevation="3"
             height="40px"
             @click="openPage('CowForm')"
             width="">
             <i class="mx-1 dstable-cow-icon dstable-cow-wticon"></i>
             <i class="mx-1 dstable-add-icon dstable-add-wticon"></i>
      </v-btn>
      <!-- fin de botón de agregar vaca -->
    </v-row>
    <!-- fin de contadores de animales -->
  </v-container>
</template>

<script>
import SystemCardCount from "../components/SystemCardCount";
import ChangeRanch from '@/components/ChangeRanch.vue';
export default {
  name: 'MobileComponents',
    data () {
      return {
      }
  },
  components: {
    SystemCardCount,
    ChangeRanch
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/MobileComponents.css';
  @import '../style/BaseStyle.css';
</style>